
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FuncionarioPesquisa } from '@app/models/funcionario-pesquisa';
import { FuncionarioPesquisaFiltros } from '@app/models/funcionario-pesquisa-filtros';
import { Funcionario } from '@app/models/funcionario';
import { ServiceBase } from '@app/services/base.service';
// import { AutocompleteDataService } from '@app/services/autocomplete.service';

@Injectable()
export class FuncionarioService extends ServiceBase {

  constructor(private http: HttpClient) {
    super();
  }
  gravar(funcionario: Funcionario, alterarSenha: boolean): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `cadastros/funcionario?alterarSenha=${alterarSenha}`, funcionario).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `cadastros/funcionario/${id}`, { headers: { meta: ['search'] }})
  }

  deletarPorId(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `cadastros/funcionario/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterLista(pesquisa: FuncionarioPesquisaFiltros, pagina: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `cadastros/funcionario/lista/?descricao=${encodeURIComponent(pesquisa.buscaTexto)}
        &tipo=${encodeURIComponent(pesquisa.buscaTipo)}
        &advogado=${pesquisa.advogado}
        &funcionario=${pesquisa.funcionario}
        &estagiario=${pesquisa.estagiario}
        &parceiro=${pesquisa.parceiro}
        &advogadoParceiro=${pesquisa.adovgadoParceiro}
        &assistenteJuridico=${pesquisa.assistenteJuridico}
        &pagina=${pagina}
        &ativo=${pesquisa.ativo}`, { headers: { meta: ['search'] }});
  }


  obter(funcionarioFiltro: FuncionarioPesquisa): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'cadastros/funcionario/lista', funcionarioFiltro);
  }

  obterTodos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'funcionario')
  }

  obterAdvogados(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'funcionario/advogados');
  }

  // obterPesquisa(pesquisa: FuncionarioPesquisaFiltros, pagina: number) {
  //   return this.http
  //    .get(this.URL_API + `funcionario/pesquisar/?descricao=${encodeURIComponent(pesquisa.buscaTexto)}
  //                                                                &tipo=${encodeURIComponent(pesquisa.buscaTipo)}
  //                                                                &advogado=${pesquisa.advogado}
  //                                                                &funcionario=${pesquisa.funcionario}
  //                                                                &estagiario=${pesquisa.estagiario}
  //                                                                &pagina=${pagina}`);
  // };

  // obterPorTermo(tipoParticipante: string): Observable<any> {
  //   return new AutocompleteDataService(this.http, this.URL_API + `funcionario/ObterAutoComplete/${tipoParticipante}`);
  // }

  obterTodasAsPermissoes(usuarioId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `cadastros/funcionario/obterTodasAsPermissoes/?usuarioId=${usuarioId}`)
      .pipe(
        catchError((error: any) => observableThrowError(error.json()))
      );
  }

  ObterTodasAsUnidadesPorUsuario(usuarioId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `cadastros/funcionario/ObterTodasAsUnidadesAcessoPorUsuario/?usuarioId=${usuarioId}`)
      .pipe(
        catchError((error: any) => observableThrowError(error.json()))
      );
  }

  verificaPermissaoUsuario(usuarioId: number, permissao: string): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `cadastros/funcionario/verificaPermissaoUsuario/?usuarioId=${usuarioId}&permissao=${permissao}`)
      .pipe(
        catchError((error: any) => observableThrowError(error.json()))
      );
  }


  // consultarCEP(cep: string) {
  //   return this.http
  //     .get<any>(`https://viacep.com.br/ws/${cep}/json/`)
  //     .pipe(
  //       catchError((error: any) => observableThrowError(error.json()))
  //     );
  // }

}
